import {Component, Input, OnInit} from '@angular/core';
import {TablePulseAbstractComponent} from '../../table-pulse-abstract/table-pulse-abstract.component';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-table-pulse-date',
  templateUrl: './table-pulse-date.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TablePulseDateComponent extends TablePulseAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService,
    private nzDatePipe: DatePipe
  ) {
    super(nzMessageService, taskHttpService, nzDatePipe);
  }

  ngOnInit(): void {
  }

}
